import React, { Fragment, useContext } from "react";
import { EligibilityContext } from "../../../contexts/EligibilityContext";

const Notifications = () => {
  const context = useContext(EligibilityContext);

  const handleSignUp = event => {
    event.preventDefault();
    context.actions.setNotificationsOptIn(true);
  };

  return (
    <Fragment>
      <p className="f-h5 c-purple u-mb1 u-mt4">Sign up for the wait list</p>
      <p>Sign up for the wait list to be notified by email when this fund opens.</p>

      <p>
        <button
          className="btn"
          type="button"
          onClick={event => handleSignUp(event)}
        >
          Sign up
        </button>
      </p>
    </Fragment>
  );
};

export default Notifications;
